export const zipLookup = async (endpoint: string, zip: string) => {
  const uri = `?action=fip-finder&zip=${zip}`;

  const controller = new AbortController();
  const terminateEarly = setTimeout(() => controller.abort(), 20000);

  const response = await fetch(`${endpoint}${uri}`, {
    method: 'GET',
    signal: controller.signal,
  });
  clearTimeout(terminateEarly);
  if (!response.ok) {
    throw new Error('ziplookup call - response was not OK');
  }
  return response.json();
};

export default zipLookup;
